
<template>
  <div class="box-block">
    <div v-if="isLoaded">
      <ValidationObserver ref="observer">
        <form @submit.prevent="validate()">
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider name="lastname" rules="required" v-slot="{ errors }">
                  <label for="client-lastname">
                    {{$t('form.lastname')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    v-model="lastname"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-lastname"
                    :placeholder="$t('form.lastname')"
                  />
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider name="firstname" rules="required" v-slot="{ errors }">
                  <label for="client-firstname">
                    {{$t('form.firstname')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    v-model="firstname"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-firstname"
                    :placeholder="$t('form.firstname')"
                  />
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-3">
              <div class="form-group">
                <label>
                  {{$t('form.gender')}}
                  <sup class="text-danger">*</sup>
                </label>
                <div>
                  <div
                    class="custom-control custom-control_light custom-radio custom-control-inline"
                  >
                    <validation-provider name="gender" rules="oneOf:1,2" v-slot="{ errors }">
                      <input
                        type="radio"
                        id="customRadioInline1"
                        v-model="gender"
                        value="1"
                        :class="{'is-invalid' : errors.length }"
                        name="customRadioInline1"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="customRadioInline1">{{$t('form.mr')}}</label>
                    </validation-provider>
                  </div>
                  <div
                    class="custom-control custom-control_light custom-radio custom-control-inline"
                  >
                    <validation-provider name="gender" rules="oneOf:1,2" v-slot="{ errors }">
                      <input
                        type="radio"
                        id="customRadioInline2"
                        v-model="gender"
                        value="2"
                        :class="{'is-invalid' : errors.length }"
                        name="customRadioInline2"
                        class="custom-control-input"
                      />
                      <label
                        class="custom-control-label"
                        for="customRadioInline2"
                      >{{$t('form.mrs')}}</label>
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider name="Firstname" rules="required" v-slot="{ errors }">
                  <label for="birthday">
                    {{$t('form.birthday')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <date-picker
                    v-model="birthday"
                    :format="$t('dateFormat')"
                    value-type="YYYY-MM-DD"
                    name="date"
                    :placeholder="$t('form.birthday')"
                    class="form-control form-control_date"
                    :class="{'is-invalid' : errors.length }"
                    :lang="local"
                    id="birthday"
                  ></date-picker>
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider name="email" rules="required|email" v-slot="{ errors }">
                  <label for="client-email">
                    {{$t('form.email')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-email"
                    :placeholder="$t('form.email')"
                  />
                  <span v-cloak class="text-danger small">{{errors[0]}}</span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <div class="form-group">
                <validation-provider name="phone" rules="required" v-slot="{ errors }">
                  <label for="client-phone">
                    {{$t('form.phone')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-phone"
                    v-model="phone"
                    :placeholder="$t('form.phone')"
                  />
                  <span class="text-danger d-none">
                    <small>{{ errors[0] }}</small>
                  </span>
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-md-8">
              <div class="form-group">
                <validation-provider name="phone" rules="required" v-slot="{ errors }">
                  <label for="client-address">
                    {{$t('form.address')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    v-model="address"
                    type="text"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-address"
                    :placeholder="$t('form.address')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider name="phone" rules="required" v-slot="{ errors }">
                  <label for="client-zipcode">
                    {{$t('form.zipcode')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    v-model="zipCode"
                    type="text"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-zipcode"
                    :placeholder="$t('form.zipcode')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider name="phone" rules="required" v-slot="{ errors }">
                  <label for="client-city">
                    {{$t('form.city')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <input
                    v-model="city"
                    type="text"
                    class="form-control"
                    :class="{'is-invalid' : errors.length }"
                    id="client-city"
                    :placeholder="$t('form.city')"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-group">
                <validation-provider name="country" rules="required" v-slot="{ errors }">
                  <label for="country">
                    {{$t('form.country')}}
                    <sup class="text-danger">*</sup>
                  </label>
                  <select
                    class="form-control p-0 pl-2"
                    v-model="country"
                    id="country"
                    :placeholder="$t('form.country')"
                    :class="{ 'is-invalid': errors.length }"
                  >
                    <option></option>
                    <option
                      v-for="item in countries"
                      :value="{'name':item.name, 'id':item.id}"
                      :key="item.id"
                    >{{ item.name }}</option>
                  </select>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">
            <button
              type="submit"
              class="btn btn-outline-secondary"
              @click.stop.prevent="resetForm"
            >{{$t('buttons.cancelButton')}}</button>
            <div v-if="monitor.visible" :class="monitor.type">{{ monitor.message }}</div>
            <button
              type="submit"
              class="btn btn-primary"
              @click.stop.prevent="save"
            >{{$t('buttons.save')}}</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div v-else class="h-100">
      <div class="h-100 row d-flex justify-content-center align-items-center">
        <div class="col-12">
          <div class="d-flex justify-content-center align-items-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Chargement...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/fr";
import "vue2-datepicker/locale/en";
import * as i18nIsoCountries from "i18n-iso-countries";
i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));
export default {
  name: "personal-informations",
  props: [],
  components: { DatePicker },
  data() {
    return {
      firstname: null,
      lastname: null,
      birthday: null,
      email: null,
      phone: null,
      gender: null,
      address: "",
      country: "",
      city: "",
      zipCode: "",
      countries: [],
      local: [],
      isLoaded: false,
      monitor: {
        visible: false,
        message: "",
        type: "text-warning"
      }
    };
  },
  created() {
    this.local = document.head.querySelector('meta[name="app-locale"]').content
    let countries = i18nIsoCountries.getNames(this.local, { select: "official" });
    this.countries = Object.entries(countries).map(([key, value]) => ({
      id: key,
      name: value
    }));
  },
  computed: {
    ...mapFields(["user"])
  },
  mounted() {
    setTimeout(() => {
      let user = this.user;
      this.reset(user);
      this.populate(user);
    }, 1500);
  },
  methods: {
    resetForm() {
      this.populate(this.user);
    },
    validate(next) {
      this.$refs.observer.validate().then(valid => {
        if (!valid) {
          this.monitor.type = "text-danger";
          this.monitor.message = this.$t('errors.requiredFields');
          this.monitor.visible = true;
          setTimeout(() => {
            this.monitorHide();
          }, 1500);
        } else {
          next();
        }
      });
    },
    save() {
      this.validate(this.update);
    },
    update() {
      let params = {};
      if (this.firstname) {
        params.firstname = this.firstname;
      }
      if (this.lastname) {
        params.lastname = this.lastname;
      }
      if (this.birthday) {
        params.birthday = this.birthday;
      }
      if (this.email) {
        params.email = this.email;
      }
      if (this.phone) {
        params.phone = this.phone;
      }
      if (this.gender) {
        params.gender = this.gender;
      }
      if (this.address) {
        params.address = this.address;
      }
      if (this.country) {
        params.country = this.country.name;
        params.country_code = this.country.id;
      }
      if (this.city) {
        params.city = this.city;
      }
      if (this.zipCode) {
        params.zipcode = this.zipCode;
      }
      this.$store
        .dispatch("updateUserInformation", params)
        .then(() => {
          this.monitor.type = "text-success";
          this.monitor.message = this.$t('updateInformations')
          this.monitor.visible = true;
          this.$store.dispatch("getAccountInformations");
          setTimeout(() => {
            this.monitorHide();
          }, 1500);
        })
        .catch(error => {
          this.monitor.type = "text-danger";
          this.monitor.message = this.$t('errors.serverError');
          this.monitor.visible = true;
          console.log(error);
        });
    },

    populate(data) {
      if (data.id) {
        this.id = data.id;
      }
      if (data.firstname) {
        this.firstname = data.firstname;
      }
      if (data.lastname) {
        this.lastname = data.lastname;
      }
      if (data.gender) {
        this.gender = data.gender;
      }
      if (data.birthday) {
        this.birthday = data.birthday;
      }
      if (data.email) {
        this.email = data.email;
      }
      if (data.phone) {
        this.phone = data.phone;
      }
      if (data.address) {
        this.address = data.address;
      }
      if (data.country) {
        this.country = {'name':data.country, 'id':data.countryCode};
      }
      if (data.city) {
        this.city = data.city;
      }
      if (data.zipcode) {
        this.zipCode = data.zipcode;
      }
      this.isLoaded = true;
    },
    reset(data) {
      this.firstname = null;
      this.lastname = null;
      this.birthday = null;
      this.email = null;
      this.phone = null;
      this.gender = 0;
      this.address = null;
      this.country = null;
      this.countryCode = null;
      this.city = null;
      this.zipcode = null;
    },
    monitorHide() {
      this.monitor.type = "";
      this.monitor.message = "";
      this.monitor.visible = false;
    }
  }
};
</script>

<style>
</style>